import { render } from "./bar-chart.vue?vue&type=template&id=ba39cff4&scoped=true&ts=true"
import script from "./bar-chart.vue?vue&type=script&lang=ts"
export * from "./bar-chart.vue?vue&type=script&lang=ts"

import "./bar-chart.vue?vue&type=style&index=0&id=ba39cff4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba39cff4"]])

export default __exports__